export class ItemMenu {
    action: String;
    i: number;
    u: number; 
    g: number; 
    subproducts: boolean;
    constructor () {
        
    } 
}


// WEBPACK FOOTER //
// ./src/app/components/rtb/context-menu/class/item-menu.ts